import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

declare global {
  interface Window {
    Userlane?: ((...args: unknown[]) => void) & {q?: unknown[][]};
    UserlaneCommandObject?: string;
  }
}

@Injectable({providedIn: 'root'})
export class UserlaneService {
  private isInitialized = false;
  private loadPromise?: Promise<void>;

  async initialize(initialLanguage?: string): Promise<void> {
    if (!environment.enableUserlane || this.isInitialized) {
      return;
    }

    await this.loadScript();

    window.Userlane?.('init', 'xn08mnqxgk');
    this.isInitialized = true;

    if (initialLanguage) {
      this.setLanguage(initialLanguage);
    }
  }

  setLanguage(languageCode: string): void {
    if (!environment.enableUserlane || !this.isInitialized) {
      return;
    }

    window.Userlane?.('lang', languageCode);
  }

  private loadScript(): Promise<void> {
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise((resolve, reject) => {
      if (window.Userlane) {
        return resolve();
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.userlane.com/userlane.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Userlane failed to load'));

      document.head.appendChild(script);
    });

    return this.loadPromise;
  }
}
